import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LogIn, Eye, EyeOff, Lock } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') navigate('/'); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(`${API}/api/auth/login`, { email: 'admin@conceptgourmet.ca', password: code }, { withCredentials: true });
      localStorage.setItem('admin_token', data.token);
      navigate('/admin/dashboard');
    } catch {
      setError('Code incorrect');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #0c0f0b, #1a1210)' }} data-testid="admin-login-page">
      <div className="w-full max-w-sm p-8 rounded-2xl" style={{ backgroundColor: '#1E241C', border: '1px solid #2C3529' }}>
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(247,138,125,0.15)' }}>
            <Lock size={24} className="text-[#F78A7D]" />
          </div>
        </div>
        <h1 className="text-2xl font-light text-white text-center mb-1" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Administration</h1>
        <p className="text-center text-xs mb-6" style={{ color: '#A1B09D' }}>Entrez le code d'acces</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <input type={showCode ? 'text' : 'password'} required value={code} onChange={e => setCode(e.target.value)}
              data-testid="admin-code-input"
              className="w-full px-4 py-3.5 pr-12 rounded-xl text-white text-sm outline-none text-center tracking-widest"
              style={{ backgroundColor: '#121611', border: '1px solid #2C3529' }}
              placeholder="Code d'acces"
              autoFocus />
            <button type="button" onClick={() => setShowCode(p => !p)}
              className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full transition-colors hover:bg-white/10"
              data-testid="admin-toggle-code">
              {showCode ? <EyeOff size={16} className="text-white/40" /> : <Eye size={16} className="text-white/40" />}
            </button>
          </div>
          {error && <p className="text-red-400 text-sm text-center" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full flex items-center justify-center gap-2 py-3 rounded-xl text-white font-semibold transition-all hover:scale-[1.02] disabled:opacity-50"
            style={{ background: 'linear-gradient(135deg, #F78A7D, #E8665A)' }}>
            <LogIn size={16} /> {loading ? 'Verification...' : 'Acceder'}
          </button>
        </form>
      </div>
    </div>
  );
}
